import { useContext } from 'react';
import ErrorMessageContext, { ErrorMessageContextType } from '../context/ErrorMessageContext';

export default (): ErrorMessageContextType => useContext(ErrorMessageContext);
